export default __webpack_public_path__ + "static/media/done.be39be5f.png";